import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { bootstrapMsal } from './utils/msalConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

bootstrapMsal()
  .then(renderApp)
  .catch((error) => {
    console.error('MSAL bootstrap failed:', error);
    root.render(
      <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
        <p>Unable to initialize sign-in. Please refresh the page.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Refresh
        </button>
      </div>
    );
  });
